import $ from 'jquery';
import { Component, ElementRef, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'top-banner',
  styleUrls: ['./top-banner.component.scss'],
  templateUrl: './top-banner.component.html',
})
export class TopBannerComponent {
  @Output() public onClose = new EventEmitter();
  public isClosable: boolean;
  private $el;

  constructor(el: ElementRef) {
    const elm = el.nativeElement;
    this.$el = $(elm);
    this.isClosable = elm.hasAttribute('closable');
  }

  public close() {
    const $el = this.$el;
    // Setting outer height to accomodate the content then setting height to 0 so css animations work
    $el.height($el.outerHeight());
    $el.outerHeight(0);
    $el.on('transitionend', () => {
      $el.addClass('closed');
      this.onClose.emit();
    });
  }
}
